import React from "react";
import Heading from "common/components/Heading";
import { grey } from "@mui/material/colors";
import { PersonOrgForm } from "common/components/PersonOrgForm";

const AddBuilder = () => {
  return (
    <div>
      <div>
        <div>
          <Heading
            variant={"h3"}
            title={"New Builder"}
            sxProp={{ fontWeight: 800, m: 2, p: 2, color: grey[600] }}
          />
        </div>
        <PersonOrgForm id={""} formName={"builder"} />
      </div>
    </div>
  );
};

export default AddBuilder;
